import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"
import Shimmer from "react-shimmer-effect";

import { Tooltip, Row, Col, Table, Button } from "reactstrap"

import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/skpService"

import DataTableBloc from '../Blocs/DataTableBloc'
import apiResponse from '../../../../../services/apiResponse'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import moment from "moment"

class TableActiveComponent extends Component {
    dataTableBloc = new DataTableBloc();

    source
    historyTable = 'historySKPtargetActive'
    defaultOrder = 'skp_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            rows: [],
            rowstt: [],
            totalRow: 0,
            totalRowtt: 0,
            loadingTable: true,
            filter: sessionStorage.getItem(this.historyTable) ?
                JSON.parse(sessionStorage.getItem(this.historyTable)) :
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }

    dateParse = (input) =>{
        let res = "";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    getEmployeeBirthDetail = (emp) => {
        let res = "";
        if (emp.employee_place_of_birth_city_uuid != null && emp.employee_place_of_birth_city_uuid != '') {
            res = `${emp.employee_place_of_birth_city_name}, ${this.dateParse(emp.employee_date_of_birth)}`;
        } else {
            res = `${emp.employee_place_of_birth_city_text}, ${this.dateParse(emp.employee_date_of_birth)}`;
        }
        return res;
    }

    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let additionalFilter = this.props.additionalFilter;

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            ...additionalFilter
        }
        await this.dataTableBloc.fetchRowTargetTable(query, this.source.token)
    }
    loadDatatt = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        let additionalFilter = this.props.additionalFilter;

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1,
            ...additionalFilter
        }
        await this.dataTableBloc.fetctthRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
        this.loadDatatt()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        await this.dataTableBloc.fetchDelete({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        this.setTokenAPI()

        this.dataTableBloc.rowtargettableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        detail: response.employee,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.dataTableBloc.rowtttableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRowtt: response.total,
                        rowstt: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.deleteChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        // this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtargettableChannel.unsubscribe()
        this.dataTableBloc.deleteChannel.unsubscribe()
    }

    columns = [
        {
            key: "skp_activity",
            text: "Kegiatan Tugas Jabatan",
            className: "skp_activity",
            sortable: true,
            // width: '80'
        },
        {
            key: "skp_realisasi_angka_kredit",
            text: "Realisasi Angka Kredit",
            className: "skp_realisasi_angka_kredit",
            sortable: true,
        },
        {
            key: "skp_realisasi_kuantitas",
            text: "Realisasi kuantitas",
            className: "skp_realisasi_kuantitas",
            sortable: true,
        },
        {
            key: "skp_realisasi_output",
            text: "Realisasi Output",
            className: "skp_realisasi_output",
            sortable: true,
        },
        {
            key: "skp_realisasi_kualitas_mutu",
            text: "Realisasi Kualitas Mutu",
            className: "skp_realisasi_kualitas_mutu",
            sortable: true,
        },
        {
            key: "skp_realisasi_waktu",
            text: "Realisasi Waktu",
            className: "skp_realisasi_waktu",
            sortable: true,
        },
        {
            key: "skp_realisasi_satuan_waktu",
            text: "Realisasi Satuan Waktu",
            className: "skp_realisasi_satuan_waktu",
            sortable: true,
        },
        {
            key: "skp_realisasi_biaya",
            text: "Realisasi Biaya",
            className: "skp_realisasi_biaya",
            sortable: true,
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.skp_period_id
                return (
                    <Fragment>
                        { accessRole('delete') ?
                                <span className="me-1">
                                    <button 
                                        className="btn btn-danger btn-sm" 
                                        id={"delete-" + thisId}
                                        onClick={() => {
                                            this.setState({
                                                inactiveUuid: record.skp_period_uuid,
                                                confirm: true
                                            })
                                        }}
                                        style={{
                                            padding: '2px 5px'
                                        }}>
                                        <i className="uil-trash-alt"></i>
                                    </button>
                                    <Tooltip
                                        style={{
                                            marginBottom: 2
                                        }}
                                        placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                        toggle={() => {
                                            this.setState({
                                                ["delete" + thisId] : !this.state["delete" + thisId]
                                            })
                                        }}
                                        >Hapus</Tooltip>
                                </span>
                            : ""
                        }

                    {/* { (accessRole('create') && record.skp_period_status==4) ? */}
                        <span>
                            <button
                                className="btn btn-warning btn-sm"
                                id={"detail-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        detailUuid: record.skp_uuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-comment-alt-edit"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail" + thisId] : !this.state["detail" + thisId]
                                    })
                                }}
                            >Input Realisasi</Tooltip>
                        </span>
                        {/* :''
                    } */}
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            // <>

            //     <MKIDatatable
            //         className={this.configDatatable.tableClass}
            //         config={this.configDatatable}
            //         records={this.state.rows}
            //         columns={this.columns}
            //         dynamic={true}
            //         minWidth={1000}
            //         total_record={this.state.totalRow}
            //         initial={this.state.filter}
            //         onChange={(filter) => {
            //             this.setState({
            //                 loadingTable: true,
            //                 filter: filter
            //             }, function () {
            //                 this.setTokenAPI()
            //             });
            //         }}
            //         loading={this.state.loadingTable}
            //     />
            //     <ConfirmAlert
            //         confirmTitle="Konfirmasi!"
            //         confirmInfo="Apakah anda yakin akan menghapus data ini?"

            //         loadingTitle="Memproses data..."
            //         loadingInfo="Tunggu beberapa saat"

            //         successTitle="Berhasil!"
            //         successInfo="Data berhasil dihapus"

            //         failedTitle="Gagal!"
            //         failedInfo="Data gagal dihapus"

            //         showConfirm={this.state.confirm}
            //         showLoading={this.state.loading}
            //         showSuccess={this.state.success}
            //         showFailed={this.state.failed}

            //         response={this.confirmResponse}
            //     />
            //     { this.state.detailUuid !== null ?
            //         // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
            //         <Redirect to={"/kepegawaian/skp.html?input_realisasi&uuid=" + this.state.detailUuid}/>
            //     : null }
            // </>
            <>
                <AvForm
                    className="needs-validation"
                    // onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                >
                    <div className="table-responsive">
                        <Table className="table-bordered table-striped">
                            <thead style={{backgroundColor:'lavender'}}>
                                <tr className="text-center">
                                    <th rowSpan="2">No</th>
                                    <th rowSpan="2" style={{minWidth:'300px'}}>Kegiatan</th>
                                    <th colSpan="2">Angka Kredit</th>
                                    <th colSpan="2">Kuantitas/Output</th>
                                    {/* <th colSpan="2">Output</th> */}
                                    <th colSpan="2">Kualitas Mutu</th>
                                    <th colSpan="2">Waktu</th>
                                    {/* <th colSpan="2">Satuan Waktu</th> */}
                                    <th colSpan="2">Biaya</th>
                                    {/* <th rowSpan="2">Catatan</th> */}
                                    <th></th>
                                </tr>
                                <tr>
                                    <th>Target</th>
                                    <th>Realisasi</th>
                                    <th>Target</th>
                                    <th>Realisasi</th>
                                    <th>Target</th>
                                    <th>Realisasi</th>
                                    <th>Target</th>
                                    <th>Realisasi</th>
                                    <th>Target</th>
                                    <th>Realisasi</th>
                                    {/* <th>Target</th>
                                    <th>Realisasi</th> */}
                                    {/* <th>Target</th>
                                    <th>Realisasi</th> */}
                                    <th>Aksi</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.totalRow > 0 ? 

                                        this.state.rows.map((data, index) => {
                                            
                                            return (
                                                <tr key={`skp_${index}`}>
                                                    <td>{index+1}</td>
                                                    <td>{data.skp_activity}</td>
                                                    <td>{data.skp_target_angka_kredit}</td>
                                                    <td>{data.skp_realisasi_angka_kredit}</td>
                                                    <td>{(data.skp_target_kuantitas)?data.skp_target_kuantitas+' ('+data.skp_target_output+')':'-'}</td>
                                                    <td>{(data.skp_realisasi_kuantitas)?data.skp_realisasi_kuantitas+' ('+data.skp_realisasi_output+')':'-'}</td>
                                                    {/* <td>{data.skp_target_output}</td> */}
                                                    {/* <td>{data.skp_realisasi_output}</td> */}
                                                    <td>{data.skp_target_kualitas_mutu}</td>
                                                    <td>{data.skp_realisasi_kualitas_mutu}</td>
                                                    <td>{data.skp_target_waktu+'('+data.skp_target_satuan_waktu+')'}</td>
                                                    <td>{(data.skp_realisasi_waktu)?data.skp_realisasi_waktu+'('+data.skp_realisasi_satuan_waktu+')':'-'}</td>
                                                    {/* <td>{data.skp_target_satuan_waktu}</td>
                                                    <td>{data.skp_realisasi_satuan_waktu}</td> */}
                                                    <td>{data.skp_target_biaya ?? '-'}</td>
                                                    <td>{data.skp_realisasi_biaya ?? '-'}</td>
                                                    {/* <td className="text-center"> */}
                                                        {/* <AvField
                                                            name={`approval_note[${index}]`}
                                                            placeholder="Catatan Approval"
                                                            errorMessage="Masukkan Catatan Approval"
                                                            type="textarea"
                                                            className="form-control"
                                                            style={{ minWidth: '200px' }}
                                                        /> */}
                                                        {/* {(data.skp_note_realisasi_boss!='')?data.skp_note_realisasi_boss:'-'}
                                                    </td> */}
                                                    <td>
                                                    <Fragment>
                                                        { (accessRole('delete') && data.skp_is_added_activity==1) ?
                                                                <span className="me-1">
                                                                    <button 
                                                                        className="btn btn-danger btn-sm" 
                                                                        id={"delete-" + data.skp_id}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                inactiveUuid: data.skp_uuid,
                                                                                confirm: true
                                                                            })
                                                                        }}
                                                                        style={{
                                                                            padding: '2px 5px'
                                                                        }}>
                                                                        <i className="uil-trash-alt"></i>
                                                                    </button>
                                                                    <Tooltip
                                                                        style={{
                                                                            marginBottom: 2
                                                                        }}
                                                                        placement="top" isOpen={this.state["delete" + data.skp_id]} target={"delete-" + data.skp_id}
                                                                        toggle={() => {
                                                                            this.setState({
                                                                                ["delete" + data.skp_id] : !this.state["delete" + data.skp_id]
                                                                            })
                                                                        }}
                                                                        >Hapus</Tooltip>
                                                                </span>
                                                            : ""
                                                        }

                                                    { (accessRole('create') && (data.skp_period_status==4 || data.skp_period_status==7)) ?
                                                        <span>
                                                            <button
                                                                className="btn btn-warning btn-sm"
                                                                id={"detail-" + data.skp_id}
                                                                onClick={() => {
                                                                    this.setState({
                                                                        detailUuid: data.skp_uuid
                                                                    })
                                                                }}
                                                                style={{
                                                                    marginRight: '2px',
                                                                    padding: '2px 5px'
                                                                }}>
                                                                    <i className="uil-comment-alt-edit"></i>
                                                            </button>
                                                            <Tooltip
                                                                style={{
                                                                    marginBottom: 2
                                                                }}
                                                                placement="top" isOpen={this.state["detail" + data.skp_id]} target={"detail-" + data.skp_id}
                                                                toggle={() => {
                                                                    this.setState({
                                                                        ["detail" + data.skp_id] : !this.state["detail" + data.skp_id]
                                                                    })
                                                                }}
                                                            >Input Realisasi</Tooltip>
                                                        </span>
                                                         :""
                                                    }
                                                    </Fragment>
                                                    </td>
                                                </tr>
                                            );
                                        })

                                    : 
                                    <tr>
                                        <td colSpan="17" className="text-center">Tidak Ada Data Menunggu Approval</td>
                                    </tr>
                                }
                                <tr style={{backgroundColor:'lavender'}}>
                                    <th></th>
                                    <th colspan="17">Tugas Tambahan dan Kreativitas</th>
                                </tr>
                                {
                                    this.state.totalRow > 0 ? 

                                        this.state.rowstt.map((data, index) => {
                                            
                                            return (
                                                <tr key={`skp_${index}`}>
                                                    <td>{index+1}</td>
                                                    <td>{data.skp_activity}</td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>
                                                    {/* <td></td> */}
                                                    {/* <td></td> */}
                                                    {/* <td></td> */}
                                                    {/* <td></td> */}
                                                    {/* <td></td> */}
                                                    <td className="text-center">
                                                        {/* <AvField
                                                            name={`approval_note[${index}]`}
                                                            placeholder="Catatan Approval"
                                                            errorMessage="Masukkan Catatan Approval"
                                                            type="textarea"
                                                            className="form-control"
                                                            style={{ minWidth: '200px' }}
                                                        /> */}
                                                        {(data.skp_note_realisasi_boss!='')?data.skp_note_realisasi_boss:'-'}
                                                    </td>
                                                    <td>
                                                    <Fragment>
                                                        { accessRole('delete') ?
                                                                <span className="me-1">
                                                                    <button 
                                                                        className="btn btn-danger btn-sm" 
                                                                        id={"delete-" + data.skp_id}
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                inactiveUuid: data.skp_uuid,
                                                                                confirm: true
                                                                            })
                                                                        }}
                                                                        style={{
                                                                            padding: '2px 5px'
                                                                        }}>
                                                                        <i className="uil-trash-alt"></i>
                                                                    </button>
                                                                    <Tooltip
                                                                        style={{
                                                                            marginBottom: 2
                                                                        }}
                                                                        placement="top" isOpen={this.state["delete" + data.skp_id]} target={"delete-" + data.skp_id}
                                                                        toggle={() => {
                                                                            this.setState({
                                                                                ["delete" + data.skp_id] : !this.state["delete" + data.skp_id]
                                                                            })
                                                                        }}
                                                                        >Hapus</Tooltip>
                                                                </span>
                                                            : ""
                                                        }

                                                    </Fragment>
                                                    </td>
                                                </tr>
                                            );
                                        })

                                    : 
                                    <tr>
                                        <td colSpan="17" className="text-center">Tidak Ada Data Menunggu Approval</td>
                                    </tr>
                                }
                            </tbody>
                        </Table>
                    </div>

                    <Row className="mb-3">
                        <Col md="9">
                            {/* <Button color="success" type="submit" disabled={this.state.totalRow > 0 ? false : true}>
                                <i className="uil-arrow-up-right"></i> Approve Realisasi Kegiatan
                            </Button> */}
                        </Col>
                    </Row>

                </AvForm>


                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    // <Redirect to={"/sample.html?detail&uuid=" + this.state.detailUuid}/>
                    <Redirect to={"/kepegawaian/skp.html?input_realisasi&uuid=" + this.state.detailUuid}/>
                : null }
            </>
        )
    }

}

export default TableActiveComponent